import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import {CdkDragDrop, moveItemInArray, transferArrayItem, copyArrayItem} from '@angular/cdk/drag-drop';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Md5 } from 'ts-md5/dist/md5';
import { ApiService } from '../../custom-material/Services/';
import { UserModel } from '../../main/Models';
import { globalData } from 'src/app/main/Models/global.model';

@Component({
  selector: 'rm-users-list',
  templateUrl: './t_users-list.component.html',
  styleUrls: ['./users-list.component.less']
})
export class UsersListComponent implements OnInit {
  
  currentUsers:Array<number>; // current users id
  societyUsers:Array<UserModel>;
  showedUsers:Array<UserModel>;
  returnUsers:Array<UserModel> = [];

  constructor(
    public dialogRef: MatDialogRef<UsersListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private apiService:ApiService,
    private gd:globalData
    ) { 
    this.currentUsers = data.currentUsers;
  }

  ngOnInit() {
    this.loadUsers().then((socUsers:Array<UserModel>)=>{
      this.societyUsers = socUsers;

      this.showedUsers = [];
      this.societyUsers.forEach((u:UserModel)=>{
        if(!this.currentUsers.includes(u.id))
          this.showedUsers.push(u);
      });
    })
  }

  loadUsers()
  {
    return new Promise((resolve, reject)=>{
      if(this.gd.societyUsers) {
        resolve(this.gd.societyUsers);
        return;
      }
      

      let params = this.apiService.createParams({
        society: this.apiService.connectedUser.society.id
      }, 'eq');
      this.apiService.getFromServer('user', params)
        .then(s=>s.subscribe((response:any)=>{
          let societyUsers = [];
          for( let i in response._embedded.user) {
            let user = new UserModel(response._embedded.user[i]);
              societyUsers.push(user);
          }
          this.gd.societyUsers = societyUsers;
          resolve(this.gd.societyUsers);
        }));
    })
  }

  add(user:UserModel)
  {
    this.dialogRef.close(user);
    /*let indexOfUser = this.returnUsers.indexOf(user);
    if(indexOfUser==-1) this.returnUsers.push(user);
    else this.returnUsers.splice(indexOfUser, 1);*/
  }
  isSelected(user:UserModel)
  {
    return this.returnUsers.includes(user);
  }
  close()
  {
    this.dialogRef.close();
  }

  getUserColor(name:string)
  {
    return '#'+Md5.hashStr(name).slice(0,6);
  }
}